import { BakeryPdf417 } from '@barcode-bakery/barcode-react/pdf417';

const  Pdf417 = ({id='pdf123'})=> {
  return (

   <>
    <div class = 'row text-center mt-2'>
        <div className ='mx-auto'>
            <BakeryPdf417 
                text   = {id} 
                scale  = {1.5}
            />
        </div>
    </div>
    <div class ='row text-center'>
           <span className ='mx-auto'>ID:{id}</span>
    </div>
   </>

);
}

export default Pdf417;

